import styled from "@emotion/styled";

import { isScreenshotTestingMode } from "../../../Testing";

export const Root = styled.span(
    props =>
        isScreenshotTestingMode() && {
            input: {
                color: "transparent",
                textShadow: `0 0 0 ${props.theme.candy.valueControls.disabledCursorTextShadowColor}`,
                ":focus": {
                    outline: "none",
                },
            },
        }
);
